import React from 'react';
/**
 * DjayAvatar part — eyes per emotion.
 * Verbatim extraction of the former `renderEyes()`. Add a new emotion's eye
 * shape by adding a `case` here (and the matching token in `DjayEmotion`).
 */
import type { DjayEmotion } from '../types';
export function Eyes({
  emotion,
  glow = false,
  glowColor = '#FDE68A'
}: {
  emotion: DjayEmotion;
  glow?: boolean;
  glowColor?: string;
}) {
  switch (emotion) {
    case 'sleeping':
      return <g className="djay-eyes" data-id="element-3465" data-mp="wclw8vpq187q">
          <path d="M60 102 Q70 108 80 102" stroke="#1E293B" strokeWidth="4" strokeLinecap="round" fill="none" data-id="element-3466" data-mp="10d5uy3py0jvz" />
          
          <path d="M120 102 Q130 108 140 102" stroke="#1E293B" strokeWidth="4" strokeLinecap="round" fill="none" data-id="element-3467" data-mp="mefvihfni84g" />
          
        </g>;
    case 'celebrating':
      return <g className="djay-eyes" data-id="element-3468" data-mp="373vj73jkpgpv">
          <path d="M60 105 Q70 95 80 105" stroke="#1E293B" strokeWidth="4" strokeLinecap="round" fill="none" data-id="element-3469" data-mp="373m1024rsduq" />
          
          <path d="M120 105 Q130 95 140 105" stroke="#1E293B" strokeWidth="4" strokeLinecap="round" fill="none" data-id="element-3470" data-mp="3c4jlwmh5zlzx" />
          
        </g>;
    case 'encouraging':
      return <g className="djay-eyes" data-id="element-3471" data-mp="30a3x0o8vjepp">
          <path d="M60 100 Q70 95 80 100" stroke="#1E293B" strokeWidth="4" strokeLinecap="round" fill="none" data-id="element-3472" data-mp="30b6l6oetb31x" />
          
          <path d="M120 100 Q130 95 140 100" stroke="#1E293B" strokeWidth="4" strokeLinecap="round" fill="none" data-id="element-3473" data-mp="3e7aco9yawxap" />
          
        </g>;
    case 'proud':
      return <g className="djay-eyes" data-id="element-3474" data-mp="3n902xcgg5q6w">
          <path d="M60 100 Q70 90 80 100" stroke="#1E293B" strokeWidth="4" strokeLinecap="round" fill="none" data-id="element-3475" data-mp="3n7ymesgnwbhs" />
          
          <path d="M70 92 L72 96 L76 96 L73 99 L74 103 L70 100 L66 103 L67 99 L64 96 L68 96 Z" fill="#FBBF24" data-id="element-3476" data-mp="ugvjzpw3b9x" />
          
          <path d="M120 100 Q130 90 140 100" stroke="#1E293B" strokeWidth="4" strokeLinecap="round" fill="none" data-id="element-3477" data-mp="3s0i0rrn6bann" />
          
          <path d="M130 92 L132 96 L136 96 L133 99 L134 103 L130 100 L126 103 L127 99 L124 96 L128 96 Z" fill="#FBBF24" data-id="element-3478" data-mp="atfugqkursjq" />
          
        </g>;
    default:
      {
        let pupilXOffset = 0,
          pupilYOffset = 0,
          pupilSize = 3.5,
          showSparkles = true;
        if (emotion === 'thinking') {
          pupilXOffset = 3;
          pupilYOffset = -3;
        } else if (emotion === 'pointing') {
          pupilXOffset = 5;
        } else if (emotion === 'surprised') {
          pupilSize = 2;
          showSparkles = false;
        }
        return <g className="djay-eyes" data-id="element-3479" data-mp="wlabjuh5mym9">
          {glow && <g className="djay-eye-glow" aria-hidden="true" data-id="element-3480" data-mp="wkhbfccpb7d3">
              <circle cx="70" cy="100" r="15" fill={glowColor} fillOpacity="0.5" data-id="element-3481" data-mp="10lkoxs7a0rb5" />
              
              <circle cx="130" cy="100" r="15" fill={glowColor} fillOpacity="0.5" data-id="element-3482" data-mp="15l5pg723h7pz" />
              
            </g>}
          <ellipse cx="70" cy="100" rx="10" ry="12" fill="white" data-id="element-3483" data-mp="1aj76ynjvgyzc" />
          <ellipse cx={72 + pupilXOffset} cy={102 + pupilYOffset} rx="6" ry="7" fill="#475569" data-id="element-3484" data-mp="37d21riw36llt" />
            
          <circle cx={73 + pupilXOffset} cy={103 + pupilYOffset} r={pupilSize} fill="#0F172A" data-id="element-3485" data-mp="3cbdb7sigyu3i" />
            
          {showSparkles && <circle cx={76 + pupilXOffset} cy={99 + pupilYOffset} r={emotion === 'excited' ? 3.5 : 2.5} fill="white" data-id="element-3486" data-mp="34t5m8ucvcu8u" />}
          {showSparkles && <circle cx={69 + pupilXOffset} cy={105 + pupilYOffset} r="1" fill="white" fillOpacity="0.7" data-id="element-3487" data-mp="2zzszyqvnwzj9" />}
          <ellipse cx="130" cy="100" rx="10" ry="12" fill="white" data-id="element-3488" data-mp="2v082ym01z196" />
          <ellipse cx={132 + pupilXOffset} cy={102 + pupilYOffset} rx="6" ry="7" fill="#475569" data-id="element-3489" data-mp="2q5135p9wmgpj" />
            
          <circle cx={133 + pupilXOffset} cy={103 + pupilYOffset} r={pupilSize} fill="#0F172A" data-id="element-3490" data-mp="3nqgis77499kl" />
            
          {showSparkles && <circle cx={136 + pupilXOffset} cy={99 + pupilYOffset} r={emotion === 'excited' ? 3.5 : 2.5} fill="white" data-id="element-3491" data-mp="3dt23wc0ucsue" />}
          {showSparkles && <circle cx={129 + pupilXOffset} cy={105 + pupilYOffset} r="1" fill="white" fillOpacity="0.7" data-id="element-3492" data-mp="38sxo6o7rc258" />}
        </g>;
      }
  }
}